import PropTypes from "prop-types";

import Hero from "components/shared/hero/Hero";
import Description from "components/shared/hero/description/Description";
import { Content, Heading } from "./RedeemHero.styled";

export default function RedeemHero({ breadcrumbsItems }) {
    return (
        <Hero breadcrumbs={breadcrumbsItems} contentWidth="half">
            <Content>
                <Heading>Inwisselen</Heading>
                <Description>
                    De Lees! Cadeaukaart is zowel online als in de winkel in te
                    wisselen bij de onderstaande acceptanten.
                </Description>
            </Content>
        </Hero>
    );
}

RedeemHero.propTypes = {
    breadcrumbsItems: PropTypes.array
};

RedeemHero.defaultProps = {
    breadcrumbsItems: [
        {
            title: "Inwisselen",
            url: "/inwisselen"
        }
    ]
};
